import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { FormDatePicker } from "@jsq/ds/forms";

const FirstTimeUpdateCard = () => {
  const datePickerName = "Custom GL date";

  return (
    <Flex flexDirection="column">
      <Text variant="strong-md">{datePickerName}</Text>
      <FormDatePicker
        displayErrorMessage
        name="firstIntegrationThroughDate"
        hasIcon
        placeholderText="Select date"
        data-testid="firstIntegrationThroughDate"
      />
    </Flex>
  );
};

export default FirstTimeUpdateCard;
